import { render, staticRenderFns } from "./EventStormingModelPanel.vue?vue&type=template&id=6fb7e7e6&scoped=true&"
import script from "./EventStormingModelPanel.vue?vue&type=script&lang=js&"
export * from "./EventStormingModelPanel.vue?vue&type=script&lang=js&"
import style0 from "./EventStormingModelPanel.vue?vue&type=style&index=0&id=6fb7e7e6&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb7e7e6",
  null
  
)

export default component.exports